// Lazy-load Google's <model-viewer> web component from CDN exactly once
// (mirrors the POC's CDN-based three.js approach — no npm dependency, no build
// weight). Shared by Cad3dViewer (single preview) and Cad3dCompare (2-pane).
const MODEL_VIEWER_CDN =
  "https://unpkg.com/@google/model-viewer@4.0.0/dist/model-viewer.min.js";

let loaderPromise: Promise<void> | null = null;

export function ensureModelViewer(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.customElements?.get("model-viewer")) return Promise.resolve();
  if (loaderPromise) return loaderPromise;
  loaderPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "module";
    script.src = MODEL_VIEWER_CDN;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load the 3D viewer."));
    document.head.appendChild(script);
  });
  return loaderPromise;
}
